export default {
  "name": "You are not there, I am",
  "slug": "you-are-not-there-i-am",
  "path": "/you-are-not-there-i-am",
  "componentName" : "YouAreNotThereIAm",
  "category": "Projects",
  "parent": false,
  "isPublic": true
}